import { Controller } from "@hotwired/stimulus"

// The help on a tool's fullscreen page (layouts/react_tool, /use): a sheet over the tool, so it's read beside the
// work and closing it leaves the work as it was. Closed by its button, Escape or a tap beside it.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    if (this.dialogTarget.open) return
    this.dialogTarget.showModal()
    this.dialogTarget.scrollTop = 0
  }

  outside(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
